import React, { useEffect, useState } from 'react';
import GridInputs from '../../../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../../../components/common/button/CustomButtons';
import useConfirm from '../../../../components/common/useConfirm';
import GridDatePicker from '../../../../components/common/inputs/GridDatePicker';
import GridSelect from '../../../../components/common/inputs/GridSelect';
import { apiConstant } from './constant';
import moment from 'moment';
import { MenuItem, SelectChangeEvent } from '@mui/material';
import { useAuth } from '../../../../services/auth/AuthProvider';

const STATUS_APPROVER_USER_ID = '6630b1321433a777c3031e7b';

const ModalInput = ({
  id,
  setIsModal,
  setListId,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setListId: any;
}) => {
  const { state } = useAuth();
  const canUpdateStatus =
    state.user?._id?.toString() === STATUS_APPROVER_USER_ID;
  const [moduleData, setMoudleData] = useState<any>({ status: 'pending' });
  const [isSubmit, setIsSubmit] = useState(false);
  const [render, setRender] = useState(false);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Customer' : 'Create Customer'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/${apiConstant.getPlanByid}/${id}`)
        .then((res) =>
          setMoudleData({ ...res.data, status: res.data?.status || 'pending' })
        )
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleData(e: React.ChangeEvent<HTMLInputElement>) {
    setMoudleData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  function handleStatus(e: SelectChangeEvent<unknown>) {
    setMoudleData((prev: any) => ({ ...prev, status: e.target.value }));
  }

  const handleSumbit = async () => {
    setIsSubmit(true);
    const ans = await confirmSubmit();
    if (!ans) return;
    const headerData = {
      title: moduleData.title,
      date_range: moduleData.date_range,
      ...(canUpdateStatus && { status: moduleData.status || 'pending' }),
    };
    if (id) {
      await axios
        .put(`/api/${apiConstant.getPlanByid}/${id}`, headerData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
          setListId('');
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post(`/api/${apiConstant.createPlanByid}`, headerData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
          setListId('');
        })
        .catch((err) => {
          setIsSubmit(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <GridInputs
        id={'title'}
        name={'title'}
        html_for={'title'}
        label_name={'Title'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.title || ''}
        onChange={handleData}
      />
      <GridDatePicker
        label_name="Date"
        html_for={'date_range'}
        views={['year']}
        value={moduleData?.date_range || null}
        onChange={(date) => {
          moduleData.date_range = moment(date._d).add(10, 'hours');
          setRender((prev) => !prev);
        }}
      />
      {canUpdateStatus && (
        <GridSelect
          name="status"
          label_name="Status"
          html_for="status"
          value={moduleData?.status || 'pending'}
          onChange={handleStatus}
        >
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="approve">Approve</MenuItem>
        </GridSelect>
      )}
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default ModalInput;
